import styled from "styled-components";

export const PhotoGray = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  filter: grayscale(1) brightness(0.95);

  &:hover {
    filter: brightness(0.95);
  }
`;
